var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDishwasher(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.932,
    height: 25.094,
    viewBox: "0 0 19.932 25.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1049",
    "data-name": "Group 1049",
    transform: "translate(-481.75 -2197.646)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1018",
    "data-name": "Rectangle 1018",
    width: 18.432,
    height: 23.594,
    rx: 1,
    transform: "translate(482.5 2198.396)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_174",
    "data-name": "Line 174",
    x2: 18.278,
    transform: "translate(482.638 2203.108)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_107",
    "data-name": "Ellipse 107",
    cx: 3.521,
    cy: 3.521,
    r: 3.521,
    transform: "translate(484.657 2211.946)",
    fill: "none",
    stroke: "#005682",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_109",
    "data-name": "Ellipse 109",
    cx: 1.122,
    cy: 1.122,
    r: 1.122,
    transform: "translate(497.163 2199.749)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1019",
    "data-name": "Rectangle 1019",
    width: 3.545,
    height: 1.368,
    rx: 0.684,
    transform: "translate(483.776 2200.188)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1028",
    "data-name": "Rectangle 1028",
    width: 7.928,
    height: 1.368,
    rx: 0.684,
    transform: "translate(488.178 2200.188)",
    fill: "#005682"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    "data-name": "Path 547",
    d: "M2924.143,17739.5s2.206,1.742,2.206,3.723-2.206,3.586-2.206,3.586",
    transform: "translate(-2431.437 -15527.688)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    "data-name": "Path 548",
    d: "M2924.143,17739.5s2.206,1.742,2.206,3.723-2.206,3.586-2.206,3.586",
    transform: "translate(-2428.224 -15527.688)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1048",
    "data-name": "Group 1048",
    transform: "translate(489.107 2205.781)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_549",
    "data-name": "Path 549",
    d: "M2999.5,17724.684v3.092",
    transform: "translate(-2996.397 -17724.684)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_550",
    "data-name": "Path 550",
    d: "M2990.833,17724.682l-.848,1.809",
    transform: "translate(-2989.985 -17724.682)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_551",
    "data-name": "Path 551",
    d: "M2989.92,17724.682l.787,1.873",
    transform: "translate(-2984.699 -17724.682)",
    fill: "none",
    stroke: "#005682",
    strokeLinecap: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDishwasher);
export default __webpack_public_path__ + "static/media/dishwasher.c0f2863380126ff0474cef0dedcb4770.svg";
export { ForwardRef as ReactComponent };